import { useTexture } from '@react-three/drei';
import * as THREE from 'three';
import configService from '../../config/config.service';
import useThemeStore from '../hooks/use-theme-store';

const flooringHeight = 0.0253999862840074;

interface FlooringModelProps {
  length: number;
  width: number;
}

export default function FlooringModel({ width, length }: FlooringModelProps) {
  const shopCode = useThemeStore((state) => state.themeCode);
  const texture = useTexture(configService.getBaseUrl(shopCode).floorImageUrl);
  return (
    <mesh rotation={[-0.5 * Math.PI, 0, 0]} receiveShadow position={[0, -flooringHeight, 0]}>
      <boxGeometry attach="geometry" args={[width, length, flooringHeight]} />
      <meshStandardMaterial attach="material" side={THREE.DoubleSide} map={texture} />
    </mesh>
  );
}
